(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ab-professional-mega"] && !Shopify.designMode) return;
  try {
    (() => {
  const alignPanels = () => {
    document.querySelectorAll('.ab-prof-mega').forEach(panel => {
      const grid = panel.closest('.mega-menu__grid');
      const item = panel.closest('.menu-list__list-item');
      const trigger = item?.querySelector('.menu-list__trigger .menu-list__link');
      if (!grid || !trigger) return;
      const bounds = grid.getBoundingClientRect();
      if (!bounds.width) return;
      const anchorX = trigger.getBoundingClientRect().left - bounds.left;
      const left = Math.max(0, Math.min(anchorX, bounds.width - 520));
      panel.style.setProperty('--ab-menu-left', Math.round(left) + 'px');
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', alignPanels, { once: true });
  else alignPanels();
  window.addEventListener('resize', alignPanels, { passive: true });
  document.addEventListener('shopify:section:load', alignPanels);
})();
  } catch(e) { console.error(e); }
})();

})();
